import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";


import styles from "./styles.module.scss";
import i18n from 'i18n';
import { capitalize } from 'helpers/utils/utils_general';
export class AddConfigTagStepTwo extends React.Component {
  render() {
    const { configTag, handleChange, options, handleSelect, goBack, handleContinue, enableContinue, error } = this.props;
    const stepContent = (
      <form onSubmit={handleContinue}>
      <div className={styles["add-config-tag-wizard-step-two-content"]}>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-height">
          <MainInput
            label={capitalize(i18n.t("measure_height")).concat(" (mm)")}
            required={true}
            id={"configTag-height"}
            name="height"
            type="number"
            value={configTag ? configTag.height : ''}
            handleChange={handleChange}
            maxLength={100}
            error={error.height && error.height}
            />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-width">
          <MainInput
              label={capitalize(i18n.t("measure_width")).concat(" (mm)")}
              required={true}
              id={"configTag-width"}
              name="width"
              type="number"
              value={configTag ? configTag.width : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.width && error.width}

            />
        </div>
        <h2 className={styles["subtitle"]}>{i18n.t("memories")}</h2>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-mem_epc">
          <MainDropdownInput
            required={true}
            id={"configTag-mem-epc"}
            name="mem-epc"
            selectedOption={configTag ? configTag.mem_epc : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'mem_epc')}
            maxLength={50}
            options={options.mem_epc}
            placeholder={i18n.t("epc.memory")}
            label={i18n.t("epc.memory")}
            error={error.mem_epc && error.mem_epc}
          />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-mem_user">
          <MainDropdownInput
            required={true}
            id={"configTag-mem-user"}
            name="mem-user"
            selectedOption={configTag ? configTag.mem_user : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'mem_user')}
            maxLength={50}
            options={options.mem_user}
            placeholder={i18n.t("user.memory")}
            label={i18n.t("user.memory")}
            error={error.mem_user && error.mem_user}
          />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-action-wrapper"]}>
          <button 
            type="button" 
            className={`${styles["add-config-tag-wizard-step-two-action-button"]} ${!enableContinue && styles["disabled"]}`} 
            onClick={enableContinue ? handleContinue : undefined} 
          >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-config-tag-wizard-step-two-container"]}>
        <Step title={i18n.t("measures")} goBackFunc={goBack} content={stepContent} MobileConfigTags={true}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepTwo;
